import { companies } from '../company'
import { describeTable } from './describeTable'

describeTable(companies, {
  description: `A legal entity in the group whose cash is forecast: the operating subsidiary Markku.fi Kiinteistöpalvelut Oy (named Markku Pientalohuolto Oy until 14.7.2026, same business ID) and the parent. Only the finance tables (cash_accounts, cash_events, cash_flow_rules) reference it; customers, visits and invoices belong to the subsidiary and carry no company_id.`,
  columns: {
    name: 'Current legal name.',
    businessId: 'Y-tunnus, unique.',
    isGroupParent:
      'True for the parent company. The group view drops both legs of every intercompany event instead of netting them.',
    fennoaKey:
      "Which Fennoa tenant holds this company's invoices and ledger: subsidiary or parent, at most one row each. Null means the company has no Fennoa of its own and nothing imports into it. The nightly refresh resolves both companies by this column.",
    fennoaUsername:
      'The Fennoa API user the refresh must be authenticated as to import into this company. A run whose credentials answer to a different user is refused, since no Fennoa payload names the tenant it came from.',
  },
})
